import React from "react";
import { MessageSquare } from "lucide-react";
import { useMessagesPanel } from "./MessagesPanelContext";

const MessagesTrigger = ({ className = "" }) => {
  const { togglePanel } = useMessagesPanel();

  return (
    <button
      type="button"
      onClick={togglePanel}
      aria-label="Messages"
      className={`relative flex items-center justify-center w-10 h-10 rounded-full text-slate-600 hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo ${className}`}
    >
      <MessageSquare className="w-5 h-5" />
    </button>
  );
};

export default MessagesTrigger;
